<template>
  <v-autocomplete
      :error-messages="error"
      variant="outlined"
      rounded="0"
      :label="translation(translationList.house_seismic_risk, 'Risc seismic')"
      :items="seismicRisks"
      item-title="name"
      item-value="id"
      name="seismic_risk"
      :loading="loading"
      :disabled="loading"
      v-model="selectedSeismicRisk"
      :rules="[v => !!v || translation(translationList.required, 'Acest câmp este obligatoriu')]"
      return-object
  >
  </v-autocomplete>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, toRefs, watch } from 'vue';
import { useHouseStore } from '~/plugins/store/house';
import { useTranslationStore, translation } from '~/plugins/store/translations';
import type { SeismicRisk } from '~/types/House';
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as () => SeismicRisk | null,
      default: () => null,
      required: false
    },
  },
  emits: ['update:modelValue', 'validation-house-status'],
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const houseStore = useHouseStore();
    const translationStore = useTranslationStore();
    const selectedSeismicRisk = ref(modelValue.value ? modelValue.value : null);
    const seismicRisks = ref<SeismicRisk[]>([]);
    const translationList = ref<TranslationList>({});
    const loading = ref(false);
    const error = ref<string[]>([]);

    onMounted(async () => {
      loading.value = true;
      seismicRisks.value = await houseStore.getSeismicRiskList();
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      loading.value = false;
      const isValid = !!selectedSeismicRisk.value;
      emit('validation-house-status', { field: 'seismic_risk', isValid });

      // Listen for validate event
      window.addEventListener('validate-house', (data) => {
        if (data.detail && data.detail === 'seismic_risk') {
          if (!selectedSeismicRisk.value) {
            error.value.push(translation(translationList.value.required, 'Acest câmp este obligatoriu'));
          } else {
            error.value = [];
            emit('validation-house-status', { field: 'seismic_risk', isValid: true });
          }
        }
      });
    });

    watch(selectedSeismicRisk, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(modelValue, (newValue) => {
      if (newValue && (newValue.id !== selectedSeismicRisk.value?.id)) {
        selectedSeismicRisk.value = newValue;
        error.value = [];
      }
      const isValid = !!newValue;
      emit('validation-house-status', { field: 'seismic_risk', isValid });
    });

    return {
      selectedSeismicRisk,
      translationList,
      translation,
      seismicRisks,
      loading,
      error,
    };
  },
});
</script>